import styled from "styled-components";

export const StyledAbout = styled.div`
    .header-about{
        position: relative;
        overflow: hidden;

        .shadow{
            position: absolute;
            width: 100%;
            top:0;
            background-color: rgba(0,0,0,0.4);
            height: 100%;
        }
        .about-video{
            position: absolute;
            min-height: 100%;
            min-width: 100%;
            z-index: -2;
        }
    }
    .main-about{
        text-align: center;
        padding: 250px 0 450px 0;
        color: white;
        position: relative;
        z-index: 2;

        h1{
            font-weight: 700;
            font-size: 96px;
            line-height: 131px;
        }

        p{
            font-size: 32px;
            line-height: 44px;
            margin-top: 30px;
            /* width: 60%; */
        }
        @media (max-width:992px) {
            h1{
                font-size: 60px;
            }
            p{
                font-size: 20px;
            }
        }
        @media (max-width:576px) {
            padding: 300px 0;
            h1{
                font-size: 40px;
                line-height: 54px;
            }
            p{
                margin-top: 15px;
                font-size: 16px;
                line-height: 22px;
            }
        }
    }

   
    .section-about{
        margin-top: 70px;


        .about-cards{
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .card{
                width: 31%;
                /* min-height: 650px; */
                margin-bottom: 40px;

                .card-img{
                    img{
                        width: 100%;
                    }
                }

                .card-info{
                    background: #FFFFFF;
                    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25);
                    padding: 30px 15px;
                    width: 100%;
                    margin-top: -5px;
                    min-height: 340px;

                    h3{
                        font-weight: 600;
                        font-size: 20px;
                        line-height: 29px;
                        margin-top: 20px;
                    }

                    p{
                        font-size: 14px;
                        line-height: 25px;
                        color: #6C6C6C;
                        margin-top: 10px;
                    }
                }
            }
        }
        @media (max-width:992px) {
            .about-cards{
                .card{
                    width: 48%;
                    .card-info{
                        svg{
                            width: 30px;
                            height: 30px;
                        }
                        h3{
                            font-size: 16px;
                            line-height: 20px;
                            margin-top: 14px;
                        }
                        p{
                            font-size: 14px;
                            line-height: 18px;
                        }
                    }
                }
            }
        }
        @media (max-width: 576px) {
            .about-cards{
                /* display: block !important; */
                /* flex-wrap: nowrap ;
                width: 2000px; */
                .card{
                    width: 100%;
                    .card-info{
                        min-height: initial;
                    }
                }
            }
        }
    }

    .section-clients{
        margin-bottom: 100px;
        .clients{
            .client-cards{
                margin-top: 50px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .card{
                    width: 31%;

                    .card-top{
                        display: flex;
                        gap:20px;
                        .card-img{
                            border: 3px solid #BB0600;
                            border-radius: 50%;
                            padding: 4 px;
                            width: 110px;
                            height: 110px;

                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        h3{
                            font-weight: 700;
                            font-size: 24px;
                            line-height: 33px;
                            margin-top: 12px;
                        }
                    }

                    .card-text{
                        position: relative;
                        background: #F1F1F1;
                        border-radius: 10px;
                        padding: 20px;
                        margin-top: 40px;
                        min-height: 400px;

                        .triangle{
                            position: absolute;
                            left:36px;
                            top: -28px;
                        }
                    }
                }
            }
        }
        @media (max-width: 992px) {
            .clients{
                .client-cards{
                    .card{
                        width: 48%;
                        margin-top: 40px;
                    }
                }
            }
        }
        @media (max-width: 768px) {
            .clients{
                .client-cards{
                    .card{
                        width: 100%;

                        .card-text{
                            min-height: initial;
                        }
                    }
                }
            }
        }
        @media (max-width: 576px) {
            .clients{
                .client-cards{
                    margin-top: 0;
                    .card{
                        width: 100%;
                        .card-top{
                            margin-left: 14px;
                            .card-img{
                                width: 50px;
                                height: 50px;
                            }
                            h3{
                                font-size: 18px;
                                line-height: 25px;
                                margin-top: 0;
                            }
                        }

                        .card-text{
                            min-height: initial;
                            .triangle{
                                left: 16px;
                            }
                        }
                    }
                }
            }
        }
    }
`